<script lang="ts">
  import Company from '$components/elements/Company.svelte';
  import type { CompanyInterface } from '$types/interfaces';

  const companies: CompanyInterface[] = [
    {
      icon: '/bible21--caramel.svg',
      name: 'Nadační fond Bible21',
      text: 'Podporuje vydávání Bible21, šíří biblickou gramotnost v české společnosti skrze rozmanité projekty a pomáhá církvím v jejich misijní práci.',
      buttonText: 'Zjistit více',
      href: '/nadacni-fond'
    },
    {
      icon: '/biblion--caramel.svg',
      name: 'Nakladatelství Biblion',
      text: 'Vydává a distribuuje Bibli21 a další kvalitní duchovní literaturu, která otevírá biblické poselství generaci 21. století.',
      buttonText: 'Navštívit Biblion',
      href: 'https://www.biblion.cz/'
    }
  ];
</script>

<div class="companies">
  {#each companies as company}
    <Company {company} />
  {/each}
</div>

<style lang="scss">
  .companies {
    width: 80%;
    max-width: 1280px;
    margin: 10px auto;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
  }
  @include mobile {
    .companies {
      width: 90%;
      grid-template-columns: 1fr;
      gap: 47px;
    }
  }
</style>
